<div class="page-wrapper">
  <div class="pagelist-topitem-container">
    <!-- main item (ReportOverviewMode,..) -->
    <div class="pagelist-topitem-buttons-container">
      <div class="pagelist-topitem-button">
        <span title="Overview mode">
          <button class="k-button k-icon k-i-grid infobar-tool-button" (click)="toggleReportOverviewMode()">
            <kendo-svg-icon class="icon" [icon]="allIcons.gridIcon"></kendo-svg-icon>
          </button>
        </span>
      </div>
    </div>
  </div>

  <!-- pages -->
  <div *ngIf="pages && pages.length">
    <kendo-sortable [kendoSortableBinding]="pages"
                    class="pagelist"
                    itemClass="PagelistItem"
                    activeItemClass="PagelistItem active"
                    (dragStart)="onDragStart($event)"
                    (dragEnd)="onDragEnd($event)">
      <ng-template let-page="item" let-index="index">
        <div class="PagelistItem PagelistItem-{{index}}" [class.activePage]="index === activePageIndex && !page.options.isHidden" [class.specialPage]="page.options.isSpecialPage">
          <div>
            <button [attr.title]="'selectPage' | translate" class="k-button k-icon k-i-checkmark infobar-tool-button" (click)="selectPage(index)" [class.infobar-tool-button-disabled]="page.options.isHidden" [class.infobar-tool-button-disabled-nocursor]="dragInProgress">
              <kendo-svg-icon class="icon" [icon]="allIcons.checkIcon"></kendo-svg-icon>
            </button>
            <button *ngIf="!isReadOnly" [attr.title]="'deletePage' | translate" class="k-button k-icon k-i-trash infobar-tool-button" (click)="deletePage(index)" [class.infobar-tool-button-disabled-nocursor]="(!page.options.canDeleteIfNotEmpty && page.widgets.length || pages.length <= 1) || dragInProgress">
              <kendo-svg-icon class="icon" [icon]="allIcons.trashIcon"></kendo-svg-icon>
            </button>
          </div>
          <div *ngIf="!isReadOnly">
            <button *ngIf="page.options.isPortrait" [attr.title]="'orientation' | translate" class="k-button k-icon k-i-file-vertical infobar-tool-button" (click)="switchOrientation(index, page.options.id)" [class.infobar-tool-button-disabled-nocursor]="page.widgets.length || dragInProgress">
              <kendo-svg-icon class="icon" [icon]="allIcons.fileIcon"></kendo-svg-icon>
            </button>
            <button *ngIf="!page.options.isPortrait" [attr.title]="'orientation' | translate" class="k-button k-icon k-i-file-horizontal infobar-tool-button" (click)="switchOrientation(index, page.options.id)" [class.infobar-tool-button-disabled-nocursor]="page.widgets.length || dragInProgress">
              <kendo-svg-icon class="icon" [icon]="allIcons.fileHorizontalIcon"></kendo-svg-icon>
            </button>
            <button [attr.title]="'addPage' | translate" class="k-button k-icon k-i-file-add infobar-tool-button" (click)="addPage(index)" [class.infobar-tool-button-disabled-nocursor]="dragInProgress">
              <kendo-svg-icon class="icon" [icon]="allIcons.fileAddIcon"></kendo-svg-icon>
            </button>
          </div>
          <div *ngIf="!isReadOnly">
            <button [attr.title]="'hidePage' | translate" class="k-button k-icon k-i-eye infobar-tool-button" (click)="toggleShowPage(index)" [class.infobar-tool-button-disabled]="page.options.isHidden" [class.infobar-tool-button-disabled-nocursor]="dragInProgress">
              <kendo-svg-icon class="icon" [icon]="allIcons.eyeIcon"></kendo-svg-icon>
            </button>
            <button [attr.title]="'addAppendixPage' | translate" class="k-button k-icon k-i-attachment infobar-tool-button" (click)="addAppendixPage(index)" [class.infobar-tool-button-disabled-nocursor]="dragInProgress">
              <kendo-svg-icon class="icon" [icon]="allIcons.paperclipIcon"></kendo-svg-icon>
            </button>
          </div>
          <div class="pagelist-page-number-button-container" [class.activePageBorder]="index == activePage">
            <button class="k-button infobar-tool-button">{{(index+1) || ''}}</button>
          </div>
        </div>
      </ng-template>
    </kendo-sortable>
  </div>
</div>
